<template>
    <form class="mass-edition-offices-form form-horizontal" @submit.prevent="submit">
        <div class="form-group">
            <label for="offices" class="col-sm-2 control-label">¿Editar todas las Oficinas?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.national"    on-text="SI" off-text="NO"></el-switch>
            </div>
        </div>
        <div v-if="!data.national" class="form-group">
            <label for="region" class="col-sm-2 control-label">Región</label>
            <div class="col-sm-10">
                <el-select filterable v-model="activeRegion" @change="comunas" placeholder="Seleccione una región" style="width:100%">
                    <el-option
                        v-for="(d,key) in groupedData"
                        :key="key"
                        :label="d[0].location.parent.parent.name"
                        :value="d[0].location.parent.parent.id"
                    ></el-option>
                </el-select> 
            </div>
        </div>
        <div v-if="!data.national" class="form-group">
            <label for="nombre" class="col-sm-2 control-label">Oficina</label>
            <div class="col-sm-10">
                <multiselect
                v-model="activeComuna"
                tag-placeholder="Agregar Oficina"
                placeholder="Busque y agregue Oficina"
                selectedLabel="Agregado"
                selectLabel="Presiones enter o click para agregar"
                deselectLabel="Presiones enter o click para eliminar"
                noOptions="Sin datos"
                label="name"
                track-by="id"
                :options="comunasFiltradas"
                :multiple="true"
                :taggable="true" 
                :disabled="disabledComuna"  
                >
                    <span slot="noOptions">
                        Sin datos
                    </span>            
                </multiselect>
                <br>
                <a v-if="activeComuna.length >0 "   @click="addOffice" role="button"><i class="material-icons">add_circle</i> Agregar</a>
                <div class="help-block" style="font-size:12px;">Al cambiar la región se deselecionaran las oficinas</div>
                <!-- <div class="help-block" v-for="e in errors['national']">{{e}}</div> -->
            </div>
        </div>
        <div v-if="!data.national && data.offices.length >0" class="form-group">
            <label for="nombre" class="col-sm-2 control-label">Oficina Seleccionadas </label>
            <div class="col-sm-10">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Región</th>
                            <th>Oficina</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(o , index) in data.offices" :key="index">
                             <td>{{getNameRegion(o.id)}}</td>
                            <td>{{o.name}}</td>
                            <td>
                                <a @click.prevent="unSelectedOffice(index)" role="button"   title="Borrar"><i class="material-icons">delete</i></a>
                            </td>

                        </tr>
                    </tbody>
                </table>
             </div>
        </div>
        <div class="form-group">
            <label for="nombre" class="col-sm-2 control-label">¿Qué atributo quieres modificar?</label>
            <div class="col-sm-10">
                <el-select placeholder="Seleccione atributo" style="width:100%" v-model="data.attributeType">
                    <el-option 
                    v-for="a in attributes"
                    :key="a.value"
                    :label="a.value"
                    :value="a.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div v-show="data.attributeType == 1"  class="form-group"  >
            <label for="opening_hours" class="col-sm-2 control-label">Horas de apertura</label>
            <div class="col-sm-10">
                <opening-hours v-model="data.opening_hours"  ></opening-hours>
                <!-- <div class="help-block" v-for="e in errors['opening_hours']">{{e}}</div> -->
            </div>
        </div>
        <div v-show="data.attributeType == 2" class="form-group">
           <label for="observations" class="col-sm-2 control-label">Observaciones generales</label>
            <div class="col-sm-10">
                <editor id="observations" v-model="observation" ></editor>

                <!-- <div class="help-block" v-for="e in errors['observations']">{{e}}</div> -->
            </div>
        </div>
        
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/oficinas">Cancelar</a>
                <button v-if="validateForm" type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<script>
import ElSwitch from 'element-ui/lib/switch';
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import Multiselect from "vue-multiselect";
import Editor from "./Editor.vue"; 
import OpeningHours from './OpeningHours.vue';

export default {
    data:function(){

        return{
            data:{
                national:true,
                offices:[],
                attributeType:null,
                opening_hours:null,
                observation:''
            },
            disabledComuna: true,
            activeRegion: [],
            activeComuna: [],
            comunasFiltradas: [],
            sucursalesFiltradas: [],
            observation:'',
            errors: {}
        }
    },
    components:{
        ElSwitch,
        ElSelect,
        ElOption,
        Multiselect,
        Editor,
        OpeningHours
    },
    props:['offices'],
    computed:{
        groupedData: function(){
                        return _(this.offices)
                    .groupBy(function(d){
                        return d.location.parent.parent.id;
                    })
                    .values()
                    .orderBy(function(d){
                    return d[0].location.parent.parent.lat;
                 }, 'desc')
                .value();
        },
        attributes:function(){
            return [
                {
                    id:1,
                    value:'Horas de apertura'
                }
                // ,
                // {
                //     id:2,
                //     value:'Observaciones generales'
                // }
            ];
        },
        validateForm:function(){
            this.errors={};

            var attributeType = this.data.attributeType === null ;
            var opening_hours = this.data.attributeType == 1 && !this.validateOpeningHours();
            var observation = this.data.attributeType == 2 && this.data.observation === '' || this.data.observation === null;
            var errores ={};

            if(attributeType)
                errores['attributeType'] =['Debe indicar el tipo de atributo a actualizar'];

            if(opening_hours)
                errores['opening_hours'] = ['Debe ingresar el horario a actualizar'];
            
            if(observation)
                errores['observation'] = ['Debe ingresar las observaciones'];

            if(attributeType || (!attributeType && opening_hours)  || (!attributeType && observation)){
                this.errors = errores;

                return false;
            }
            else
                return true;


        }
    },
    methods:{
       comunas: function (selected) {
            if (selected){ 
                this.disabledComuna = false;
                this.activeComuna = []; 
                this.comunasFiltradas=[]; 

                var aux = _(this.offices)
                    .filter(function(d){
                    return d.location.parent.parent_id === selected && d.mobile === false;
                })
                .groupBy(function(d){
                    return d.location.id;
                })
                .values()
                .orderBy(function(d){
                    return d[0].location.name;
                }, 'asc')
                .value();

                aux.forEach(e => {
                    if(e.length == 1){
                        this.comunasFiltradas.push(e[0]);
                        this.setSelectedOffices(e[0]); 
                    }
                    else{
                        e.forEach(o=>{
                            this.comunasFiltradas.push(o);
                            this.setSelectedOffices(o); 
                        });
                    }
                });
            }
        },
        setSelectedOffices:function(office){
            var self = this;

            var oficina = self.data.offices.find(e => e.id == office.id);

            if(oficina)
                self.activeComuna.push(office);  
           

        },
        validateOpeningHours:function(){
            var opening_hours={};
            var flag = false;

            if(this.$children.length>0){
                opening_hours = this.$children.find(function(e){ return e.$el.className == 'opening-hours'; });

                if(opening_hours._data){
                    opening_hours._data.openingHours.forEach(function(o){
                            if(o.dayOfWeek.length >0){
                                flag = true;
                            } 
                        }
                    );
                }
            }

            return flag;
        },
        addOffice : function(){
            var self = this;

            self.activeComuna.forEach(e=>{
                if(!this.data.offices.find(o=> o.id == e.id))
                    this.data.offices.push(e);
            });
            
            this.activeComuna = [];
            this.errors={};
            this.activeRegion = '';
            this.disabledComuna = true;
            
        } ,
        getNameRegion:function(id){
            return this.offices.find(e => e.id == id).location.parent.parent.name;            
        },
        unSelectedOffice:function(index){
            var self = this;

            self.$confirm('¿Está seguro de quitar la oficina?','Atención',{
                confirmButtonText:'Eliminar',
                cancelButtonText: 'Cancelar',
                type:'warning'
            }).then(() => {
                var selected = self.data.offices[index];
                
                if(selected){
                    var selectedIndex = self.activeComuna.findIndex(e => e.id == selected.id);
                    self.activeComuna.splice(selectedIndex,1);
                }
                self.data.offices.splice(index,1);               
            }).catch();

        },
        submit:function(){
            var self = this;

            if(!self.validateForm){
                self.$message.error('Revise los errores en el formulario antes de continuar.');
            }
            else{
                var msg =  self.data.national ? ' a nivel Nacional':' a las ' + self.data.offices.length + ' Oficinas seleccionadas';

                self.$confirm('Se realizaran modificaciones' + msg + ', ¿Está seguro de realizar la actualización?','Atención',{
                    confirmButtonText:'Actualizar',
                    cancelButtonText: 'Cancelar',
                    type:'warning'
                }).then(() => {
                    
                    axios({
                        url: 'backend/oficinas/actualizacion-masiva',
                        method:'PUT',
                        data: self.data
                    }).then(response => {
                        if(response.status == 200)
                            window.location.replace('backend/oficinas');
                    }).catch(function(error){
                        self.error = error.response.data.errors;
                    });
                }).catch(() => {
                    self.$message({
                        type: 'info',
                        message: 'Actualización cancelada'
                    });
                });


                
            }
        }
    }
}
</script>